<div class="left-panel">
    <div class="zoneiq-top-panel"></div>
    <mat-list class="links-list">
        <mat-list-item class="item-title" ngClass="{{isOpened('is-not-calibrated-reasons') ? 'active' : ''}}">
            <span class="totals-item" [routerLink]="['is-not-calibrated-reasons']">Is Not Calibrated Reasons</span>
        </mat-list-item>
        <mat-list-item class="item-title" ngClass="{{isOpened('gridics-uses-tags') ? 'active' : ''}}">
            <span class="totals-item" [routerLink]="['gridics-uses-tags']">Gridics Uses Tags</span>
        </mat-list-item>
    </mat-list>
</div>

<mat-divider [vertical]="true"></mat-divider>

<div class="central-panel">
    <router-outlet></router-outlet>
</div>
